import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";

//3rd party
import * as Icon from 'react-bootstrap-icons';

//Styles
import '../css/header.css';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const Header = () => {
    const { t, loading: i18nLoading, languageCode, setLanguage } = useTranslations();

    const navigate = useNavigate();
    const functie_id = localStorage.getItem('functie_id');

    //Logout function
    const logout = () => {
        localStorage.removeItem("bearerToken");
        localStorage.removeItem("ingelogd");
        localStorage.removeItem("formdata");
        navigate("/login");
    }

    const current_path = window.location.pathname;
    return(
        <div>
            <div className="header-mobile">
                {/* Language picker */}
                <li className="lang-picker">
                    <button
                        className={`lang-btn ${languageCode === 'nl' ? 'active' : ''}`}
                        onClick={() => setLanguage('nl')}
                        aria-label="Switch language to Dutch"
                    >
                        NL
                    </button>
                    <span className="lang-sep">|</span>
                    <button
                        className={`lang-btn ${languageCode === 'en' ? 'active' : ''}`}
                        onClick={() => setLanguage('en')}
                        aria-label="Switch language to English"
                    >
                        EN
                    </button>
                </li>
            </div>
            <div className="header">
                <div className="header-container">
                    <div className="logo">
                        <img src={require('../assets/images/logo.png')} alt="Gemini Teak" onClick={() => navigate("/")} />
                    </div>
                    <div className="nav">
                        <ul>
                            <li className={current_path == '/' ? 'cta' : 'normal'} onClick={() => navigate("/")}><Icon.ClockHistory />{t('day_state', 'Day state')}</li>
                            {functie_id == 4 ? //Directie
                                <li className={current_path == '/overview' ? 'cta' : 'normal'} onClick={() => navigate("/overview")}><Icon.ClockHistory />{t('overview', 'Overview')}</li>
                            : null}
                            <li className={current_path == '/verlof' ? 'cta' : 'normal'} onClick={() => navigate("/verlof")}><Icon.Receipt />{t('leave_of_absence', 'Leave of absence')}</li>
                            {functie_id == 3 || functie_id == 4 || functie_id == 6 ? //Voorman, Directie, voorman tekenkamer
                                <li className={current_path == '/verlof/review' ? 'cta' : 'normal'} onClick={() => navigate("/verlof/review")}><Icon.Receipt />{t('review_leave_requests', 'Review leave requests')}</li>
                            : null}
                            {functie_id == 3 || functie_id == 4 || functie_id == 6 ? //Voorman, Directie, voorman tekenkamer
                                <li className={current_path == '/hours/review' ? 'cta' : 'normal'} onClick={() => navigate("/hours/review")}><Icon.ClockHistory />{t('review_hours', 'Review hours')}</li>
                            : null}
                            <li className="with-icon logout" onClick={logout}>{t('logout', 'Logout')} <Icon.BoxArrowInRight /></li>

                            {/* Language picker */}
                            <li className="lang-picker">
                                <button
                                    className={`lang-btn ${languageCode === 'nl' ? 'active' : ''}`}
                                    onClick={() => setLanguage('nl')}
                                    aria-label="Switch language to Dutch"
                                >
                                    NL
                                </button>
                                <span className="lang-sep">|</span>
                                <button
                                    className={`lang-btn ${languageCode === 'en' ? 'active' : ''}`}
                                    onClick={() => setLanguage('en')}
                                    aria-label="Switch language to English"
                                >
                                    EN
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;